import { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Stack } from '@mui/material'
import { useStytchB2BClient } from '@stytch/react/b2b'
import { getRedirectUrl } from '@/utils/auth'
import { showErrorSnackbar } from '@/utils/snackbars'
import { PixyDocsForm } from '@/components/forms'
import { Email, LoginViewOptions } from './Login'
import MagicLinkRequested from './request-views/MagicLinkRequested'

type FormValues = {
  email: string
}

export default function LoginWithMagicLink({
  stytchOrg,
  resetView,
  setShowOnly,
  ...rest
}: LoginViewOptions) {
  const stytch = useStytchB2BClient()

  const [view, setView] = useState<'login' | 'magic_link_request'>('login')
  const methods = useForm<FormValues>({
    defaultValues: {
      email: '',
    },
  })
  const {
    formState: { isValid, dirtyFields },
  } = methods

  const handleOnSubmit = useCallback(
    async (values: FormValues) => {
      try {
        if (stytchOrg) {
          await stytch.magicLinks.email.loginOrSignup({
            email_address: values.email,
            organization_id: stytchOrg.organization_id,
            login_redirect_url: getRedirectUrl(),
          })
        } else {
          await stytch.magicLinks.email.discovery.send({
            email_address: values.email,
            discovery_redirect_url: getRedirectUrl(),
          })
        }
        setView('magic_link_request')
        setShowOnly('magic_link')
      } catch (e) {
        console.error('Error during sign in:', e)
        showErrorSnackbar(
          'An error occurred during the request. Please try again.',
        )
      }
    },
    [stytchOrg, setShowOnly, stytch.magicLinks.email],
  )

  useEffect(() => {
    if (resetView) {
      setView('login')
    }
  }, [resetView])

  return view == 'login' ? (
    <PixyDocsForm
      methods={methods}
      onSubmit={handleOnSubmit}
      style={{ width: '100%' }}
    >
      <Stack spacing={2}>
        <Email {...rest} />
        {/* For some reason isDirty won't work, but dirtyFields does */}
        <Button type="submit" disabled={!isValid || !dirtyFields.email}>
          Continue with Email
        </Button>
      </Stack>
    </PixyDocsForm>
  ) : (
    <MagicLinkRequested email={rest.email} />
  )
}
